import { render, staticRenderFns } from "./Narocilo.vue?vue&type=template&id=6f595bbe&"
import script from "./Narocilo.vue?vue&type=script&lang=js&"
export * from "./Narocilo.vue?vue&type=script&lang=js&"
import style0 from "./Narocilo.vue?vue&type=style&index=0&id=6f595bbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports